export const days = i => fullDay[i].substring(0, 3);

export const fullDay = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];
